import ajaxService from './ajaxService';

export default {
  // 取得會員資料
  postLINEUserId(body) {
    return ajaxService.post('/com/post/api/v1/lineuserid', body);
  },
};
